import styles from "./styles.module.css";
import { useState } from "react";
import Toggle from "./toggle";
import API from "./api";
import Webhooks from "./webhooks";

export default function Sidebar({ api, webhook, toggle }) {
  return (
    <div className={styles.sidebar}>
      <Toggle toggle={toggle} />
      {toggle.value === "api" ? (
        <API selected={api} />
      ) : (
        <Webhooks selected={webhook} />
      )}
    </div>
  );
}
